export const STORAGE_KEY = "tohdoh";
// Must match backend MAX_ACTIVE_ITEMS (backend/src/api/items.ts).
export const MAX_ITEMS = 20;
// Must match backend undo window (backend/src/api/items.ts deleteItem).
export const UNDO_DURATION_MS = 10_000;
// Item text max length. Must match backend validateText.
export const MAX_TEXT_LENGTH = 50;
// Display name max length. Must match backend validateCreatedByName.
export const MAX_NAME_LENGTH = 20;
// List name max length. Must match backend validateListName.
export const MAX_LIST_NAME_LENGTH = 50;
